import { ThunkAction } from 'redux-thunk';
import * as Actions from './actions';
import * as UserActions from '../user/actions';
import { AnyAction } from 'redux';
import AuthService from '../../../utils/BkpAuthService';
import { AppState } from '../../store';
import { setCookie } from '../../utils/cookie';
import { SigninErrorState } from './types';

const toSigninErrorStatus = (status?: number): SigninErrorState => {
  switch (status) {
    case 404:
      return 'not_found';
    case 401:
      return 'auth_failed';
    case 422:
      return 'invalid';
    default:
      return 'error';
  }
};

export const submitLoginForm = (): ThunkAction<Promise<void>, AppState, {}, AnyAction> => async (
  dispatch,
  getState
) => {
  dispatch(Actions.startToSignin());

  const { identifyValue, password } = getState().signInForm;

  // 電話番号でマッチしたら電話番号によるログイン試行を行う
  const phoneRegex = /^0{1}\d{8,13}$/;
  const isPhoneNumber = phoneRegex.test(identifyValue.value);

  try {
    const data = isPhoneNumber
      ? await AuthService.loginWithPhoneNumber(identifyValue.value, password.value)
      : await AuthService.loginWithEmail(identifyValue.value, password.value);

    setCookie('access_token', data.accessToken);
    setCookie('refresh_token', data.refreshToken);
    setCookie('user_id', data.userId);
    setCookie(isPhoneNumber ? 'phone_number' : 'email', identifyValue.value);

    // 成功を受けて画面遷移するため、ユーザー情報を先に入れておく
    dispatch(
      isPhoneNumber ? UserActions.setPhoneNumber(identifyValue.value) : UserActions.setEmail(identifyValue.value)
    );
    dispatch(UserActions.setAccessToken(data.accessToken));
    dispatch(UserActions.setUserId(data.userId));
    dispatch(UserActions.setRefreshToken(data.refreshToken));

    dispatch(Actions.signinSuccess());
  } catch (error) {
    const status = error ? (error as { status?: number }).status : undefined;
    dispatch(Actions.signinFailed(toSigninErrorStatus(status)));
  }
};
